import { useLicenseRolesQuery } from "./useLicenseRolesQuery";

export const useFreeRoles = () => {
    const { data } = useLicenseRolesQuery("FREE", true);

    return data?.roles?.map((role) => role.value);
};
